import React, { useState } from "react";

const StepEmail = ({ email, setEmail, setDone, onApply }) => {
  const [editing, setEditing] = useState(!email);
  const [input, setInput] = useState(email || "");

  const handleApply = () => {
    if (onApply) {
      onApply(input);
    } else {
      setEmail(input);
      setEditing(false);
      setDone(true);
    }
  };

  return (
    <div className="flex items-center gap-3">
      <input
        type="email"
        className={`px-4 py-2 rounded border-2 text-lg font-semibold transition-all focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-500 bg-blue-50 text-blue-800 ${editing ? '' : 'bg-gray-100 text-gray-400'} w-64`}
        value={editing ? input : email}
        onChange={e => setInput(e.target.value)}
        readOnly={!editing}
        disabled={!editing}
        placeholder="이메일을 입력하세요"
        onKeyDown={e => { if (e.key === 'Enter' && editing) handleApply(); }}
      />
      <button
        className={`px-4 py-2 rounded font-bold transition-colors shadow ${editing ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-200 text-gray-600 hover:bg-gray-300'}`}
        onClick={() => { editing ? handleApply() : setEditing(true); }}
      >
        {editing ? '적용' : '수정'}
      </button>
    </div>
  );
};

export default StepEmail; 